var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, queryAssignedElements, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { appendStylesToTheStyleRoot } from '../../utilities/dom';
import styles from './sds-cm-item.lit.scss';
import stylesGlobal from './_sds-cm-item-global.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
/**
 * `sds-cm-item` is a web component representing an individual item within a context menu.
 * It provides various customization options, such as icons, tooltips, and secondary labels.
 * The component can be used as a regular menu item or a section heading, depending on the configuration.
 *
 * ### Features:
 * - Primary and secondary labels for better clarity.
 * - Configurable icons and avatars to enhance the visual presentation.
 * - Optional tooltips for additional context on hover.
 * - Can act as a menu item or a section heading.
 * - Supports disabled state to prevent interactions when needed.
 */
let SdsContextMenuItem = (() => {
    var _SdsContextMenuItem__avatar_accessor_storage, _SdsContextMenuItem__icon_accessor_storage, _SdsContextMenuItem_name_accessor_storage, _SdsContextMenuItem__value_accessor_storage, _SdsContextMenuItem_subname_accessor_storage, _SdsContextMenuItem_description_accessor_storage, _SdsContextMenuItem_disabled_accessor_storage, _SdsContextMenuItem_heading_accessor_storage, _SdsContextMenuItem_withIcon_accessor_storage, _SdsContextMenuItem_tooltip_accessor_storage, _SdsContextMenuItem_withAvatar_accessor_storage, _SdsContextMenuItem_focused_accessor_storage, _SdsContextMenuItem_href_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-cm-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let __avatar_decorators;
    let __avatar_initializers = [];
    let __avatar_extraInitializers = [];
    let __icon_decorators;
    let __icon_initializers = [];
    let __icon_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _set_value_decorators;
    let _subname_decorators;
    let _subname_initializers = [];
    let _subname_extraInitializers = [];
    let _description_decorators;
    let _description_initializers = [];
    let _description_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _heading_decorators;
    let _heading_initializers = [];
    let _heading_extraInitializers = [];
    let _set_identifier_decorators;
    let _withIcon_decorators;
    let _withIcon_initializers = [];
    let _withIcon_extraInitializers = [];
    let _tooltip_decorators;
    let _tooltip_initializers = [];
    let _tooltip_extraInitializers = [];
    let _withAvatar_decorators;
    let _withAvatar_initializers = [];
    let _withAvatar_extraInitializers = [];
    let _focused_decorators;
    let _focused_initializers = [];
    let _focused_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    var SdsContextMenuItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            this.stylesGlobal = (__runInitializers(this, _instanceExtraInitializers), stylesGlobal);
            _SdsContextMenuItem__avatar_accessor_storage.set(this, __runInitializers(this, __avatar_initializers, void 0));
            _SdsContextMenuItem__icon_accessor_storage.set(this, (__runInitializers(this, __avatar_extraInitializers), __runInitializers(this, __icon_initializers, void 0)));
            _SdsContextMenuItem_name_accessor_storage.set(this, (__runInitializers(this, __icon_extraInitializers), __runInitializers(this, _name_initializers, '')));
            _SdsContextMenuItem__value_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), undefined));
            _SdsContextMenuItem_subname_accessor_storage.set(this, __runInitializers(this, _subname_initializers, ''));
            _SdsContextMenuItem_description_accessor_storage.set(this, (__runInitializers(this, _subname_extraInitializers), __runInitializers(this, _description_initializers, '')));
            _SdsContextMenuItem_disabled_accessor_storage.set(this, (__runInitializers(this, _description_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsContextMenuItem_heading_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _heading_initializers, false)));
            /**
             * A unique identifier for the context menu item, allowing it to be referenced
             * programmatically or distinguished from other items.
             *
             * Defaults to `undefined`.
             *
             * @attr {string} identifier - A unique identifier for the menu item.
             */
            this._identifier = __runInitializers(this, _heading_extraInitializers);
            _SdsContextMenuItem_withIcon_accessor_storage.set(this, __runInitializers(this, _withIcon_initializers, false));
            _SdsContextMenuItem_tooltip_accessor_storage.set(this, (__runInitializers(this, _withIcon_extraInitializers), __runInitializers(this, _tooltip_initializers, '')));
            _SdsContextMenuItem_withAvatar_accessor_storage.set(this, (__runInitializers(this, _tooltip_extraInitializers), __runInitializers(this, _withAvatar_initializers, false)));
            _SdsContextMenuItem_focused_accessor_storage.set(this, (__runInitializers(this, _withAvatar_extraInitializers), __runInitializers(this, _focused_initializers, false)));
            _SdsContextMenuItem_href_accessor_storage.set(this, (__runInitializers(this, _focused_extraInitializers), __runInitializers(this, _href_initializers, '')));
            this.updateAvatar = (__runInitializers(this, _href_extraInitializers), () => {
                var _a;
                if (this.withAvatar && this.isSlotPresent(this._avatar)) {
                    (_a = this._avatar) === null || _a === void 0 ? void 0 : _a.forEach(avatar => (avatar.disabled = this.disabled));
                }
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            this.handleClick = (event) => {
                event === null || event === void 0 ? void 0 : event.preventDefault();
                if (!this.disabled) {
                    this.dispatchEvent(new CustomEvent(SdsContextMenuItem.CM_ITEM_CLICKED, {
                        detail: {
                            identifier: this.identifier,
                        },
                        bubbles: false,
                        composed: false,
                    }));
                }
            };
        }
        get _avatar() { return __classPrivateFieldGet(this, _SdsContextMenuItem__avatar_accessor_storage, "f"); }
        set _avatar(value) { __classPrivateFieldSet(this, _SdsContextMenuItem__avatar_accessor_storage, value, "f"); }
        get avatar() {
            return this._avatar;
        }
        get _icon() { return __classPrivateFieldGet(this, _SdsContextMenuItem__icon_accessor_storage, "f"); }
        set _icon(value) { __classPrivateFieldSet(this, _SdsContextMenuItem__icon_accessor_storage, value, "f"); }
        get icon() {
            return this._icon;
        }
        /**
         * The name or primary label of the context menu item.
         * This is displayed as the main text for the item.
         *
         * Defaults to an empty string (`''`).
         *
         * @attr {string} name - The primary label of the menu item.
         */
        get name() { return __classPrivateFieldGet(this, _SdsContextMenuItem_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_name_accessor_storage, value, "f"); }
        /**
         * The value of the context menu item.
         * This is displayed as the main value for the item.
         *
         * Defaults to an empty string (`''`).
         *
         * @attr {string} value - The primary value of the menu item.
         */
        get _value() { return __classPrivateFieldGet(this, _SdsContextMenuItem__value_accessor_storage, "f"); }
        set _value(value) { __classPrivateFieldSet(this, _SdsContextMenuItem__value_accessor_storage, value, "f"); }
        set value(value) {
            this._value = value;
            this.identifier = value;
        }
        get value() {
            return this._value;
        }
        /**
         * A secondary label or subname for the context menu item, typically used for
         * additional information or descriptions.
         *
         * Defaults to an empty string (`''`).
         *
         * @attr {string} subname - The secondary label of the menu item.
         * @deprecated - Use `description` instead
         */
        get subname() { return __classPrivateFieldGet(this, _SdsContextMenuItem_subname_accessor_storage, "f"); }
        set subname(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_subname_accessor_storage, value, "f"); }
        /**
         * A secondary label for the context menu item, typically used for
         * additional information or descriptions.
         *
         * Defaults to an empty string (`''`).
         *
         * @attr {string} description - The secondary label of the menu item.
         */
        get description() { return __classPrivateFieldGet(this, _SdsContextMenuItem_description_accessor_storage, "f"); }
        set description(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_description_accessor_storage, value, "f"); }
        /**
         * Determines whether the context menu item is disabled.
         * When `true`, the item cannot be interacted with.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} disabled - Disables the menu item.
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsContextMenuItem_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_disabled_accessor_storage, value, "f"); }
        /**
         * Indicates if the context menu item serves as a heading.
         * When `true`, the item is styled differently to represent a section header.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} heading - Marks the item as a heading.
         */
        get heading() { return __classPrivateFieldGet(this, _SdsContextMenuItem_heading_accessor_storage, "f"); }
        set heading(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_heading_accessor_storage, value, "f"); }
        set identifier(identifier) {
            this._identifier = identifier;
            this._value = identifier;
        }
        get identifier() {
            return this._identifier;
        }
        /**
         * Controls whether the context menu item displays an icon.
         * When `true`, an icon is rendered alongside the item's label.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} with-icon - Displays an icon with the menu item.
         */
        get withIcon() { return __classPrivateFieldGet(this, _SdsContextMenuItem_withIcon_accessor_storage, "f"); }
        set withIcon(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_withIcon_accessor_storage, value, "f"); }
        /**
         * Specifies the tooltip text for the menu item. This text is displayed when the user
         * hovers over the item.
         *
         * Defaults to an empty string (`''`).
         *
         * @attr {string} tooltip - The tooltip text for the menu item.
         */
        get tooltip() { return __classPrivateFieldGet(this, _SdsContextMenuItem_tooltip_accessor_storage, "f"); }
        set tooltip(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_tooltip_accessor_storage, value, "f"); }
        /**
         * Controls whether an avatar is displayed with the menu item.
         * When `true`, an avatar is shown alongside the item's label.
         *
         * Defaults to `false`.
         *
         * @attr {boolean} with-avatar - Displays an avatar with the menu item.
         */
        get withAvatar() { return __classPrivateFieldGet(this, _SdsContextMenuItem_withAvatar_accessor_storage, "f"); }
        set withAvatar(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_withAvatar_accessor_storage, value, "f"); }
        /**
         * Indicates whether the context menu item is currently focused.
         * When set to `true`, it visually signifies that the item is selected or ready for user interaction.
         * This can help in enhancing keyboard navigation and accessibility.
         *
         * Defaults to `false`.
         *
         * This property doesn't have a corresponding attribute.
         */
        get focused() { return __classPrivateFieldGet(this, _SdsContextMenuItem_focused_accessor_storage, "f"); }
        set focused(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_focused_accessor_storage, value, "f"); }
        get href() { return __classPrivateFieldGet(this, _SdsContextMenuItem_href_accessor_storage, "f"); }
        set href(value) { __classPrivateFieldSet(this, _SdsContextMenuItem_href_accessor_storage, value, "f"); }
        updated(changedProperties) {
            super.updated(changedProperties);
            // Implement roving tabindex pattern for accessibility
            if (changedProperties.has('focused')) {
                const contextMenu = this.closest('sds-context-menu');
                // Check if we're in a select component (either directly or through shadow DOM)
                let isInSelectWithInput = false;
                let isInMultiselectWithInput = false;
                // First try direct traversal
                if (this.closest('sds-select:not([simple])')) {
                    isInSelectWithInput = true;
                }
                else if (this.closest('sds-multi-select:not([simple])')) {
                    isInMultiselectWithInput = true;
                }
                // If we're in a shadow root, check the host element
                if (!isInSelectWithInput &&
                    !isInMultiselectWithInput &&
                    this.getRootNode() instanceof ShadowRoot) {
                    const shadowRoot = this.getRootNode();
                    const host = shadowRoot.host;
                    if (host.closest('sds-select:not([simple])')) {
                        isInSelectWithInput = true;
                    }
                    else if (host.closest('sds-multi-select:not([simple])')) {
                        isInMultiselectWithInput = true;
                    }
                }
                // Fallback for "Select All" item in non-simple multiselect
                const isSelectAllItem = this.id === 'select-all-item';
                const isInNonSimpleMultiselect = isInMultiselectWithInput ||
                    (isSelectAllItem && (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.id) === 'multiselect-menu');
                // Check if we're in a menu component (not select/multiselect)
                const isInMenu = !!(this.closest('sds-menu') || (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.closest('sds-menu')));
                // Only prevent focus() for non-simple select/multiselect (with input) and menu components
                const shouldPreventFocus = isInSelectWithInput || isInNonSimpleMultiselect || isInMenu;
                this.setAttribute('role', 'option');
                this.tabIndex = this.focused ? 0 : -1;
                // Call focus() for menu items but prevent scroll, don't call for select/multiselect with input
                if (this.focused && !shouldPreventFocus) {
                    this.focus();
                }
                else if (this.focused && isInMenu) {
                    // Call focus() with preventScroll option if available, otherwise use a different approach
                    if (this.focus && typeof this.focus === 'function') {
                        // Try to use preventScroll option (modern browsers)
                        try {
                            this.focus({ preventScroll: true });
                        }
                        catch (e) {
                            // Fallback for older browsers
                            this.focus();
                        }
                    }
                }
            }
        }
        render() {
            appendStylesToTheStyleRoot(this, 'sds-cm-item', this.stylesGlobal.cssText);
            //TODO Kadmos: style action part and show only on hover
            return this.renderInWrapper(html `
                ${this.renderIcon()}
                <div class="sds-cm-item__content">
                    ${this.renderAvatar()} ${this.renderName()} ${this.renderDescription()}
                </div>
                <slot name="actions"></slot>
            `);
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        renderName() {
            if (this.name) {
                return html `
                <div class="sds-cm-item__title" part="sds-cm-item-title">
                    <sds-clipped-text text="${this.name}" basic></sds-clipped-text>
                </div>
            `;
            }
        }
        renderDescription() {
            if (this.description || this.subname) {
                return html `
                <div class="sds-cm-item__description">${this.description || this.subname}</div>
            `;
            }
        }
        renderIcon() {
            if (this.withIcon) {
                if (this.tooltip !== undefined && this.tooltip !== '') {
                    return html `
                    <sds-tooltip position="up">
                        <slot slot="trigger" name="icon" class="sds-cm-item__only-icon"></slot>
                        <div slot="text">${this.tooltip}</div>
                    </sds-tooltip>
                `;
                }
                else {
                    const iconClass = this.name ? 'sds-cm-item__icon' : '';
                    return html `<slot name="icon" class=${iconClass}></slot>`;
                }
            }
        }
        renderAvatar() {
            if (this.withAvatar) {
                return html ` <slot name="avatar" @slotchange="${this.updateAvatar}"></slot> `;
            }
        }
        renderInWrapper(content) {
            if (this.href) {
                return html `
                <a href="${this.href}" @click="${this.handleClick}" class="${this.getClasses()}"
                    >${content}</a
                >
            `;
            }
            return html `
            <div class="${this.getClasses()}" @click="${this.handleClick}">${content}</div>
        `;
        }
        getClasses() {
            const classes = {
                'sds-cm-item': true,
                'sds-cm-item--heading': this.heading,
                'sds-cm-item--has-icon': this.withIcon,
                'sds-cm-item--disabled': this.disabled,
                'sds-cm-item--focused': this.focused,
            };
            return classMap(classes);
        }
        isSlotPresent(slot) {
            return !slot || slot.length > 0;
        }
        dispatchPropertyChange(propertyName, newValue, oldValue) {
            const event = new CustomEvent(SdsContextMenuItem.CM_ITEM_PROPERTY_CHANGE, {
                detail: Object.assign({ identifier: this.identifier, propertyName,
                    newValue }, (oldValue !== undefined && { oldValue })),
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(event);
        }
    };
    _SdsContextMenuItem__avatar_accessor_storage = new WeakMap();
    _SdsContextMenuItem__icon_accessor_storage = new WeakMap();
    _SdsContextMenuItem_name_accessor_storage = new WeakMap();
    _SdsContextMenuItem__value_accessor_storage = new WeakMap();
    _SdsContextMenuItem_subname_accessor_storage = new WeakMap();
    _SdsContextMenuItem_description_accessor_storage = new WeakMap();
    _SdsContextMenuItem_disabled_accessor_storage = new WeakMap();
    _SdsContextMenuItem_heading_accessor_storage = new WeakMap();
    _SdsContextMenuItem_withIcon_accessor_storage = new WeakMap();
    _SdsContextMenuItem_tooltip_accessor_storage = new WeakMap();
    _SdsContextMenuItem_withAvatar_accessor_storage = new WeakMap();
    _SdsContextMenuItem_focused_accessor_storage = new WeakMap();
    _SdsContextMenuItem_href_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsContextMenuItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        __avatar_decorators = [queryAssignedElements({ slot: 'avatar' })];
        __icon_decorators = [queryAssignedElements({ slot: 'icon' })];
        _name_decorators = [property()];
        _set_value_decorators = [property()];
        _subname_decorators = [property()];
        _description_decorators = [property()];
        _disabled_decorators = [property({ type: Boolean })];
        _heading_decorators = [property({ type: Boolean })];
        _set_identifier_decorators = [property()];
        _withIcon_decorators = [property({ type: Boolean, attribute: 'with-icon' })];
        _tooltip_decorators = [property({ type: String, attribute: 'tooltip' })];
        _withAvatar_decorators = [property({ type: Boolean, attribute: 'with-avatar' })];
        _focused_decorators = [state()];
        _href_decorators = [property({ type: String, reflect: true })];
        __esDecorate(_classThis, null, __avatar_decorators, { kind: "accessor", name: "_avatar", static: false, private: false, access: { has: obj => "_avatar" in obj, get: obj => obj._avatar, set: (obj, value) => { obj._avatar = value; } }, metadata: _metadata }, __avatar_initializers, __avatar_extraInitializers);
        __esDecorate(_classThis, null, __icon_decorators, { kind: "accessor", name: "_icon", static: false, private: false, access: { has: obj => "_icon" in obj, get: obj => obj._icon, set: (obj, value) => { obj._icon = value; } }, metadata: _metadata }, __icon_initializers, __icon_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _set_value_decorators, { kind: "setter", name: "value", static: false, private: false, access: { has: obj => "value" in obj, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _subname_decorators, { kind: "accessor", name: "subname", static: false, private: false, access: { has: obj => "subname" in obj, get: obj => obj.subname, set: (obj, value) => { obj.subname = value; } }, metadata: _metadata }, _subname_initializers, _subname_extraInitializers);
        __esDecorate(_classThis, null, _description_decorators, { kind: "accessor", name: "description", static: false, private: false, access: { has: obj => "description" in obj, get: obj => obj.description, set: (obj, value) => { obj.description = value; } }, metadata: _metadata }, _description_initializers, _description_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _heading_decorators, { kind: "accessor", name: "heading", static: false, private: false, access: { has: obj => "heading" in obj, get: obj => obj.heading, set: (obj, value) => { obj.heading = value; } }, metadata: _metadata }, _heading_initializers, _heading_extraInitializers);
        __esDecorate(_classThis, null, _set_identifier_decorators, { kind: "setter", name: "identifier", static: false, private: false, access: { has: obj => "identifier" in obj, set: (obj, value) => { obj.identifier = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
        __esDecorate(_classThis, null, _withIcon_decorators, { kind: "accessor", name: "withIcon", static: false, private: false, access: { has: obj => "withIcon" in obj, get: obj => obj.withIcon, set: (obj, value) => { obj.withIcon = value; } }, metadata: _metadata }, _withIcon_initializers, _withIcon_extraInitializers);
        __esDecorate(_classThis, null, _tooltip_decorators, { kind: "accessor", name: "tooltip", static: false, private: false, access: { has: obj => "tooltip" in obj, get: obj => obj.tooltip, set: (obj, value) => { obj.tooltip = value; } }, metadata: _metadata }, _tooltip_initializers, _tooltip_extraInitializers);
        __esDecorate(_classThis, null, _withAvatar_decorators, { kind: "accessor", name: "withAvatar", static: false, private: false, access: { has: obj => "withAvatar" in obj, get: obj => obj.withAvatar, set: (obj, value) => { obj.withAvatar = value; } }, metadata: _metadata }, _withAvatar_initializers, _withAvatar_extraInitializers);
        __esDecorate(_classThis, null, _focused_decorators, { kind: "accessor", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, get: obj => obj.focused, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, _focused_initializers, _focused_extraInitializers);
        __esDecorate(_classThis, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsContextMenuItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CM_ITEM_CLICKED = 'sds.cm.item.clicked';
    _classThis.CM_ITEM_PROPERTY_CHANGE = 'sds.cm.item.property.change';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsContextMenuItem = _classThis;
})();
export { SdsContextMenuItem };
